module.exports = __webpack_public_path__ + "img/jl-icon_1.8aeeecba.png";